import { Injectable } from '@angular/core';
import {
  AutomationConditionType,
  AutomationRuleGroupBoolean,
  AutomationTriggerFieldChangeRuleType,
} from '@kinet-open-network/shared/data-access/model';
import { generateAutomationId } from '../automation-id-generator.util';

export interface IFieldChangeRule {
  id: string;
  type: AutomationConditionType.Rule;
  rule: AutomationTriggerFieldChangeRuleType;
  key: string;
  operator?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}

export interface IFieldChangeRuleGroup {
  id: string;
  type: AutomationConditionType.Group;
  collapsed?: boolean;
  boolean: AutomationRuleGroupBoolean;
  children: (IFieldChangeRule | IFieldChangeRuleGroup)[];
}

@Injectable()
export class FieldChangeTriggerService {
  createRule(rule?: AutomationTriggerFieldChangeRuleType): IFieldChangeRule {
    return {
      id: this.generateId(),
      type: AutomationConditionType.Rule,
      rule: rule || AutomationTriggerFieldChangeRuleType.newValue,
      key: '',
      value: null,
    };
  }

  createRuleGroup(): IFieldChangeRuleGroup {
    return {
      id: this.generateId(),
      type: AutomationConditionType.Group,
      collapsed: false,
      boolean: AutomationRuleGroupBoolean.And,
      children: [],
    };
  }

  generateId(): string {
    return generateAutomationId();
  }
}
